import BaseApiService from "./base-services/baseApi.service";

class HomeApiService extends BaseApiService {
    constructor() {
        super();
    }

    getHomeList = async () => {
        const url = `/website/home-page/fetch`;
        const res = await this.axiosInstance.get(url);
        return await res.data;
    };

    getOnlineReport = async (payload) => {
        const url = `/access/report`;
        const res = await this.axiosInstance.post(url, payload);
        return res;
    };

    getHomeEarliestAvailableSlots = async (pincode) => {
        for (let flag = 0; flag <= 2; flag++) {
            const url = `/website/home-earliest-avail?pincode=${pincode}&flag=${flag}`;
            const res = await this.axiosInstance.get(url);

            if (res.data && Object.keys(res.data.data).length) {
                return res.data.data;
            }
        }

        return null;
    };

    getHomeRatesBasedOnPincode = async (data) => {
        const url = `/website/test/pincode/rates`;
        const res = await this.axiosInstance.post(url, data);

        return await res.data.data;
    };
}

const homeApiService = new HomeApiService();
export { homeApiService };
